// eslint-disable-next-line import/no-cycle
import { getApi, postApi } from '@/shared/api';

export default {
	namespaced: true,
	state: () => ({
		env: process.env.NODE_ENV === 'development' ? 'beta' : 'prod',
	}),
	actions: {
		// eslint-disable-next-line camelcase
		async checkSubscriptions(_, { token }) {
			// const response = await getApi(`http://192.168.5.24:5001/api/v1/push/check-subscription?token=${token}`);
			// eslint-disable-next-line camelcase
			// const response = await getApi(`/notification/${state.env}/api/v1/push/check-subscription?token=${token}`);
			const response = await getApi(`/k5/v1/user/push/check-subscription?token=${token}`);
			return response;
		},
		// eslint-disable-next-line camelcase
		async subscribe(_, { token }) {
			// const response = await postApi('http://192.168.5.24:5001/api/v1/push/subscribe', { token });
			// const response = await postApi(`/notification/${state.env}/api/v1/push/subscribe`, { token });
			const response = await postApi('/k5/v1/user/push/subscribe', { token });
			return response;
		},
		// eslint-disable-next-line camelcase
		async unsubscribe({ state }, { subscription_uid }) {
			// const response = await postApi('http://192.168.5.24:5001/api/v1/push/unsubscribe', { subscription_uid });
			const response = await postApi(`/notification/${state.env}/api/v1/push/unsubscribe`, { subscription_uid });
			return response;
		},
		async confirmPushOpening(_, uid) {
			const response = await getApi(`/k5/v1/user/push/confirm-push-opening?sub_to_mailing=${uid}`);
			return response;
		},
	},
};
